(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["litejam-media-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('lj-media-gallery')) return;

    class LjMediaGallery extends HTMLElement {
      /* When the section is on a page more than once, the 2nd, 3rd … galleries are connected as soon as
         their opening tag is parsed, before their cards exist. Wait until the page has finished parsing. */
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      init() {
        if (!this.isConnected || this.ac) return;
        this.rail = this.querySelector('[data-ljmg-rail]');
        if (!this.rail) return;
        this.viewport = this.rail.parentElement;
        this.cards = Array.from(this.rail.querySelectorAll('[data-ljmg-card]'));
        this.prevBtns = Array.from(this.querySelectorAll('[data-ljmg-prev]'));
        this.nextBtns = Array.from(this.querySelectorAll('[data-ljmg-next]'));
        this.dotsWrap = this.querySelector('[data-ljmg-dots]');
        this.thumb = this.querySelector('[data-ljmg-thumb]');
        this.positions = [0];
        this.max = 0;
        this.pending = null;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = !this.reduced;
        this.snap = this.dataset.snap === 'true';
        if (!this.autoplay) this.classList.add('ljmg--toggle');

        this.ac = new AbortController();
        const opt = { signal: this.ac.signal };
        const passive = { signal: this.ac.signal, passive: true };

        this.rail.addEventListener('scroll', () => this.queueUpdate(), passive);
        ['wheel', 'touchstart'].forEach((type) => this.rail.addEventListener(type, () => { this.pending = null; }, passive));
        this.prevBtns.forEach((btn) => btn.addEventListener('click', () => this.go(-1), opt));
        this.nextBtns.forEach((btn) => btn.addEventListener('click', () => this.go(1), opt));
        this.rail.addEventListener('keydown', (event) => this.onKey(event), opt);
        if (this.dataset.drag === 'true') this.initDrag(opt);
        this.initMedia(opt);
        this.querySelectorAll('img[data-ljmg-yt]').forEach((img) => this.ytThumb(img));

        document.addEventListener('visibilitychange', () => this.syncAll(), opt);
        document.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), opt);

        if ('ResizeObserver' in window) {
          /* watch the rail and every card: a card can change width while the rail stays the same size */
          this.resizeObserver = new ResizeObserver(() => this.queueMeasure());
          this.resizeObserver.observe(this);
          this.resizeObserver.observe(this.rail);
          this.cards.forEach((card) => this.resizeObserver.observe(card));
        } else {
          window.addEventListener('resize', () => this.queueMeasure(), opt);
        }
        /* measure again once fonts, images and late theme styles have settled */
        window.addEventListener('load', () => this.queueMeasure(), opt);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.queueMeasure());
        this.measure();
        requestAnimationFrame(() => this.measure());
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        this.ac = null;
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.io) this.io.disconnect();
        if (this.settle) this.settle();
        cancelAnimationFrame(this.raf);
        cancelAnimationFrame(this.measureRaf);
        this.stopMomentum();
        this.querySelectorAll('video').forEach((video) => video.pause());
      }

      /* ---------- layout ---------- */
      /* "Scroll to the screen edge": distance from the page width (where the heading sits) to the section's
         left / right edge. The cards area reaches out by that much, and the first card keeps the heading's line. */
      measureBleed() {
        if (!this.classList.contains('ljmg--bleed')) return;
        const host = this.closest('.section') || this.closest('.shopify-section') || document.body;
        const h = host.getBoundingClientRect();
        const m = this.getBoundingClientRect();
        if (!m.width || !h.width) return;
        const l = Math.max(0, Math.round(m.left - h.left));
        const r = Math.max(0, Math.round(h.right - m.right));
        if (l !== this.bl) {
          this.bl = l;
          this.style.setProperty('--ljmg-bl', `${l}px`);
        }
        if (r !== this.br) {
          this.br = r;
          this.style.setProperty('--ljmg-br', `${r}px`);
        }
      }

      measure() {
        this.measureBleed();
        const rail = this.rail;
        const pad = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
        /* Browser zoom and fractional card widths leave a few pixels of "overflow" even when every
           card fits. Treat anything under SLACK px as nothing to scroll, and merge stops that close. */
        const SLACK = 24;
        let max = Math.max(0, rail.scrollWidth - rail.clientWidth);
        if (max < SLACK) max = 0;
        const positions = [];
        this.cards.forEach((card) => {
          const x = Math.min(max, Math.max(0, card.offsetLeft - pad));
          if (!positions.length || x - positions[positions.length - 1] > SLACK) positions.push(x);
        });
        if (!positions.length) positions.push(0);
        this.max = max;
        this.positions = positions;
        /* a hidden gallery (display: none, collapsed tab) measures 0 wide: wait until it is shown */
        if (!rail.clientWidth) return;
        this.classList.toggle('ljmg-static', max === 0);
        this.classList.remove('ljmg-pending');
        if (this.dotsWrap && (!this.dots || this.dots.length !== positions.length || this.dotsWrap.childElementCount !== positions.length)) this.buildDots();

        const media = this.cards[0] && this.cards[0].querySelector('.ljmg__media');
        if (media && this.viewport) {
          const top = media.getBoundingClientRect().top - this.viewport.getBoundingClientRect().top;
          this.style.setProperty('--ljmg-arrow-y', `${Math.round(top + media.offsetHeight / 2)}px`);
        }
        this.update();
      }

      queueMeasure() {
        if (this.measureRaf) return;
        this.measureRaf = requestAnimationFrame(() => {
          this.measureRaf = 0;
          if (this.isConnected) this.measure();
        });
      }

      buildDots() {
        this.dotsWrap.textContent = '';
        this.dots = this.positions.map((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ljmg__dot';
          dot.tabIndex = -1;
          const bar = document.createElement('span');
          bar.className = 'ljmg__dot-bar';
          dot.appendChild(bar);
          dot.addEventListener('click', () => this.scrollToX(this.positions[i]));
          this.dotsWrap.appendChild(dot);
          return dot;
        });
      }

      queueUpdate() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          this.update();
        });
      }

      update() {
        const x = this.rail.scrollLeft;
        const max = this.max;
        if (this.pending !== null && Math.abs(x - this.pending) < 2) this.pending = null;
        this.prevBtns.forEach((btn) => { btn.disabled = x <= 2; });
        this.nextBtns.forEach((btn) => { btn.disabled = x >= max - 2; });
        if (this.dots) {
          const active = this.nearest(x);
          this.dots.forEach((dot, i) => dot.classList.toggle('ljmg-active', i === active));
        }
        if (this.thumb) {
          const size = this.rail.scrollWidth ? Math.min(1, this.rail.clientWidth / this.rail.scrollWidth) : 1;
          const progress = max > 0 ? x / max : 0;
          this.thumb.style.width = `${size * 100}%`;
          this.thumb.style.left = `${progress * (1 - size) * 100}%`;
        }
      }

      nearest(x) {
        let index = 0;
        let best = Infinity;
        this.positions.forEach((p, i) => {
          const d = Math.abs(p - x);
          if (d < best) {
            best = d;
            index = i;
          }
        });
        return index;
      }

      go(dir) {
        const base = this.pending !== null ? this.pending : this.rail.scrollLeft;
        let target = dir > 0
          ? this.positions.find((p) => p > base + 4)
          : this.positions.slice().reverse().find((p) => p < base - 4);
        if (target === undefined) target = dir > 0 ? this.max : 0;
        this.scrollToX(target);
      }

      scrollToX(x) {
        this.stopMomentum();
        this.pending = x;
        clearTimeout(this.pendingTimer);
        this.pendingTimer = setTimeout(() => { this.pending = null; }, 900);
        this.rail.scrollTo({ left: x, behavior: this.reduced ? 'auto' : 'smooth' });
      }

      onKey(event) {
        if (event.target !== this.rail) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(event.key === 'ArrowRight' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.scrollToX(event.key === 'Home' ? 0 : this.max);
        }
      }

      onBlockSelect(event) {
        const card = event.target && event.target.closest ? event.target.closest('[data-ljmg-card]') : null;
        if (!card || !this.contains(card)) return;
        const pad = parseFloat(getComputedStyle(this.rail).paddingLeft) || 0;
        this.scrollToX(Math.min(this.max, Math.max(0, card.offsetLeft - pad)));
      }

      /* ---------- mouse drag (touch and trackpads scroll natively) ---------- */
      initDrag(opt) {
        const rail = this.rail;

        rail.addEventListener('pointerdown', (event) => {
          this.dragged = false;
          this.pending = null;
          if (event.pointerType !== 'mouse' || event.button !== 0 || this.max === 0) return;
          if (event.target.closest('button, input, select, textarea, iframe, video[controls]')) return;
          event.preventDefault(); /* no text selection or native image/link drag; clicks still work */
          this.stopMomentum();
          this.drag = { id: event.pointerId, x0: event.clientX, left0: rail.scrollLeft, lastX: event.clientX, lastT: performance.now(), v: 0, moved: false };
        }, opt);

        rail.addEventListener('pointermove', (event) => {
          const d = this.drag;
          if (!d || event.pointerId !== d.id) return;
          const dx = event.clientX - d.x0;
          if (!d.moved) {
            if (Math.abs(dx) < 6) return;
            d.moved = true;
            if (this.settle) this.settle();
            try { rail.setPointerCapture(d.id); } catch (e) { /* ignore */ }
            this.classList.add('ljmg-dragging');
            const selection = window.getSelection && window.getSelection();
            if (selection && selection.removeAllRanges) selection.removeAllRanges();
          }
          event.preventDefault();
          rail.scrollLeft = d.left0 - dx;
          const now = performance.now();
          const dt = Math.max(1, now - d.lastT);
          d.v = 0.8 * ((event.clientX - d.lastX) / dt) + 0.2 * d.v;
          d.lastX = event.clientX;
          d.lastT = now;
        }, opt);

        const end = (event) => {
          const d = this.drag;
          if (!d || event.pointerId !== d.id) return;
          this.drag = null;
          if (!d.moved) return;
          this.dragged = true;
          setTimeout(() => { this.dragged = false; }, 60);
          try { rail.releasePointerCapture(d.id); } catch (e) { /* ignore */ }
          this.release(performance.now() - d.lastT > 80 ? 0 : d.v);
        };
        rail.addEventListener('pointerup', end, opt);
        rail.addEventListener('pointercancel', end, opt);

        /* a drag should not also open the link under the mouse */
        rail.addEventListener('click', (event) => {
          if (!this.dragged) return;
          this.dragged = false;
          event.preventDefault();
          event.stopPropagation();
        }, { signal: opt.signal, capture: true });
        rail.addEventListener('dragstart', (event) => event.preventDefault(), opt);
      }

      release(v) {
        const rail = this.rail;
        if (this.snap) {
          const target = this.positions[this.nearest(rail.scrollLeft - v * 220)];
          this.scrollToX(target);
          this.afterScroll(() => this.classList.remove('ljmg-dragging'));
          return;
        }
        let velocity = -v * 16;
        const step = () => {
          velocity *= 0.94;
          const before = rail.scrollLeft;
          rail.scrollLeft = before + velocity;
          if (Math.abs(velocity) < 0.5 || rail.scrollLeft === before) {
            this.momentum = 0;
            this.classList.remove('ljmg-dragging');
            return;
          }
          this.momentum = requestAnimationFrame(step);
        };
        this.momentum = requestAnimationFrame(step);
      }

      stopMomentum() {
        if (this.momentum) {
          cancelAnimationFrame(this.momentum);
          this.momentum = 0;
        }
      }

      afterScroll(callback) {
        if (this.settle) this.settle();
        const rail = this.rail;
        let timer;
        const cleanup = () => {
          clearTimeout(timer);
          rail.removeEventListener('scroll', onScroll);
          this.settle = null;
        };
        const finish = () => {
          cleanup();
          callback();
        };
        const onScroll = () => {
          clearTimeout(timer);
          timer = setTimeout(finish, 120);
        };
        rail.addEventListener('scroll', onScroll, { passive: true });
        timer = setTimeout(finish, 200);
        this.settle = cleanup;
      }

      /* YouTube cover: sharpest thumbnail first (1280px, no black bars), then fall back.
         A missing size comes back as a 120px grey image or an error. */
      ytThumb(img) {
        const id = img.dataset.ljmgYt;
        const steps = ['maxresdefault', 'hq720', 'hqdefault'];
        const check = () => {
          if (img.naturalWidth > 120) return;
          const current = steps.findIndex((name) => img.src.indexOf(`/${name}.jpg`) > -1);
          const next = steps[current + 1];
          if (!next) return;
          if (next === 'hqdefault') img.classList.add('ljmg-letterboxed');
          img.src = `https://i.ytimg.com/vi/${id}/${next}.jpg`;
        };
        img.addEventListener('load', check);
        img.addEventListener('error', check);
        if (img.complete) check();
      }

      /* ---------- video ---------- */
      initMedia(opt) {
        this.state = new Map();
        this.querySelectorAll('[data-ljmg-media]').forEach((media) => {
          const kind = media.dataset.kind;
          if (kind !== 'autoplay' && kind !== 'click' && kind !== 'embed') return;
          const st = { kind, inView: false, visible: false, userPaused: !this.autoplay };
          this.state.set(media, st);

          const video = media.querySelector('video');
          if (video) {
            const ready = () => media.classList.add('ljmg-ready');
            video.addEventListener('loadeddata', ready, opt);
            video.addEventListener('playing', ready, opt);
          }
          const toggle = media.querySelector('[data-ljmg-toggle]');
          if (toggle) {
            toggle.addEventListener('click', () => {
              st.userPaused = !st.userPaused;
              this.sync(media);
            }, opt);
          }
          const play = media.querySelector('[data-ljmg-play]');
          if (play) play.addEventListener('click', () => this.start(media), opt);
        });
        if (!this.state.size) return;

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              const st = this.state.get(entry.target);
              if (!st) return;
              st.visible = entry.isIntersecting;
              st.inView = entry.isIntersecting && entry.intersectionRatio >= 0.5;
              this.sync(entry.target);
            });
          }, { threshold: [0, 0.5] });
          this.state.forEach((st, media) => this.io.observe(media));
        } else {
          this.state.forEach((st, media) => {
            st.visible = true;
            st.inView = true;
            this.sync(media);
          });
        }
      }

      load(video) {
        if (!video.getAttribute('src') && video.dataset.src) video.setAttribute('src', video.dataset.src);
      }

      sync(media) {
        const st = this.state && this.state.get(media);
        if (!st) return;
        const video = media.querySelector('video');

        if (st.kind === 'autoplay' && video) {
          if (st.inView && !st.userPaused && !document.hidden) {
            this.load(video);
            const attempt = video.play();
            if (attempt && attempt.catch) {
              attempt.catch((error) => {
                if (error && error.name === 'NotAllowedError') {
                  st.userPaused = true;
                  this.classList.add('ljmg--toggle');
                  this.paintToggle(media, st);
                }
              });
            }
          } else if (!video.paused) {
            video.pause();
          }
          this.paintToggle(media, st);
        } else if (st.kind === 'click' && video) {
          if ((!st.visible || document.hidden) && !video.paused) video.pause();
        } else if (st.kind === 'embed') {
          if (!st.visible && media.classList.contains('ljmg-playing')) this.stop(media);
        }
      }

      paintToggle(media, st) {
        const toggle = media.querySelector('[data-ljmg-toggle]');
        if (!toggle) return;
        toggle.classList.toggle('ljmg-paused', st.userPaused);
        toggle.setAttribute('aria-label', st.userPaused ? 'Play video' : 'Pause video');
      }

      syncAll() {
        if (this.state) this.state.forEach((st, media) => this.sync(media));
      }

      start(media) {
        const st = this.state.get(media);
        if (!st) return;
        if (this.active && this.active !== media) this.stop(this.active);
        this.active = media;

        if (st.kind === 'click') {
          const video = media.querySelector('video');
          if (!video) return;
          this.load(video);
          video.controls = true;
          video.muted = false;
          media.classList.add('ljmg-playing');
          const attempt = video.play();
          if (attempt && attempt.catch) {
            attempt.catch(() => {
              video.muted = true;
              video.play().catch(() => {});
            });
          }
          video.focus({ preventScroll: true });
        } else if (st.kind === 'embed') {
          const button = media.querySelector('[data-ljmg-play]');
          const src = button && button.dataset.embed;
          if (!src) return;
          const frame = document.createElement('iframe');
          frame.className = 'ljmg__frame';
          frame.src = src;
          frame.title = button.getAttribute('aria-label') || 'Video';
          frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          frame.allowFullscreen = true;
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          media.appendChild(frame);
          media.classList.add('ljmg-playing');
          frame.focus({ preventScroll: true });
        }
      }

      stop(media) {
        const st = this.state.get(media);
        if (!st) return;
        if (st.kind === 'click') {
          const video = media.querySelector('video');
          if (video && !video.paused) video.pause();
        } else if (st.kind === 'embed') {
          const frame = media.querySelector('.ljmg__frame');
          if (frame) frame.remove();
          media.classList.remove('ljmg-playing');
        }
        if (this.active === media) this.active = null;
      }
    }

    customElements.define('lj-media-gallery', LjMediaGallery);
  })();

  } catch(e) { console.error(e); }
})();
})();
